import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { GoogleAuthService } from '../services/google-auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const googleAuthService = inject(GoogleAuthService);
  const token = googleAuthService.getSessionToken();

  // Only add auth header for API requests to our backend
  if (req.url.includes('/api/') && token) {
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
    return next(authReq);
  }

  return next(req);
}; 